import { render, staticRenderFns } from "./ProductCount.vue?vue&type=template&id=987bb64e&"
import script from "./ProductCount.vue?vue&type=script&lang=ts&"
export * from "./ProductCount.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports